module.exports = __webpack_public_path__ + "static/media/common_grandpa_default.fa86fdf1.png";